export default __webpack_public_path__ + "static/media/vacasa-logo-horizontal-blue.50ed5dc0.svg";